import { action } from 'easy-peasy';
import { IActionSetClinicMembers } from '../types';

const setClinicMembers: IActionSetClinicMembers = action((state, payload) => {
  state.clinicMembers = payload.sort((a, b) => (a.lastName < b.lastName ? -1 : 1));
});

export default setClinicMembers;
